const MARKETING_SEGMENTS = new Set([
  'start',
  'preturi',
  'termeni',
  'confidentialitate',
])

/** Platform-host marketing pages (not a shop). Custom domains never use these. */
export function isPlatformMarketingPath(path: string, customDomainShop = false): boolean {
  if (customDomainShop) return false
  if (path.startsWith('/platform')) return true
  const normalized = path.replace(/\/+$/, '') || '/'
  if (normalized === '/') return true
  const first = normalized.split('/').filter(Boolean)[0]?.toLowerCase() || ''
  return MARKETING_SEGMENTS.has(first)
}
